module.exports = __webpack_public_path__ + "media/images/ac_templates/201/yelht-a0378e475e0067ee64bc3ad704343529.jpg";